import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Workshop } from './Workshop.js';

/**
 * @entity WorkshopAttendanceCount
 */
@Entity()
export class WorkshopAttendanceCount extends AdornisEntity {
  public static override _class = 'WorkshopAttendanceCount';

  public static override resolveID(entity: any): string {
    return entity.workshopID;
  }

  @DataLoadedField(() => Workshop, ({ workshopID }) => workshopID)
  public workshop: Maybe<Workshop>;

  @Field(() => String)
  public workshopID: Maybe<string>;

  @Field(() => Int)
  public eventCount: Maybe<number>;

  @Field(() => Int)
  public attendanceCount: Maybe<number>;

  @Field(() => Int)
  public attendanceCountMin: Maybe<number>;

  @Field(() => Int)
  public attendanceCountMax: Maybe<number>;
}
